// finds if a specific class is parent of our element, and if so returns it
export const validateIfParentExists = (el, className) => {
	while (el && el.parentNode) {
		el = el.parentNode
		if (el.className && el.className.toLowerCase().includes(className)) {
			return el
		}
	}

	// Many DOM methods return null if they don't find the element they are searching for
	return null
}

/**
@firstEmptyFieldIdentifier {String} - element Id
@returns {Number} - value of offset top of element
*/
export const getElementOffsetTopPosition = (firstEmptyFieldIdentifier) => {
	if (!document.getElementById(firstEmptyFieldIdentifier)) return 0
	return document.getElementById(firstEmptyFieldIdentifier).offsetTop
}

/**
* checks if it is in view, if not moves scroll to show element
@container {DOM element}
@element {DOM element}
@returns {void}
*/
export const checkIfElementIsVisible = (container, keyboardHeight) => {
	if (window.cordova?.platformId === 'ios') {
		setTimeout(() => {
			/* Determine container top and bottom */
			const containerTop = container.getBoundingClientRect().top
			const containerBottom = containerTop + container.clientHeight
			const parentWithScroll = validateIfParentExists(container, 'features-base-content-wrapper')
			const footerHeight = validateIfParentExists(container, 'showing-footer') ? 62 : 0

			/* Keyboard now resizes the viewport on both iOS and Android,
			so window.innerHeight already reflects the available space. */
			const elementIsHidden = window.innerHeight < containerBottom
			console.log(containerBottom, window.innerHeight, parentWithScroll)

			if (parentWithScroll && elementIsHidden) {
				const currentScrollTop = parentWithScroll.scrollTop
				const scrollOffset = (containerBottom - window.innerHeight) + footerHeight + 24

				parentWithScroll.scrollTop = currentScrollTop + scrollOffset
			}
		}, 1000)
	} else {
		/* Determine container top and bottom */
		const containerTop = container.getBoundingClientRect().top
		const containerBottom = containerTop + container.clientHeight
		const parentWithScroll = validateIfParentExists(container, 'features-base-content-wrapper')
		const footerHeight = validateIfParentExists(container, 'showing-footer') ? 62 : 0

		const elementIsHidden = window.innerHeight - parseInt(keyboardHeight) < containerBottom

		if (parentWithScroll && elementIsHidden) {
			const currentScrollTop = parentWithScroll.scrollTop

			setTimeout(() => {
				parentWithScroll.scrollTop = currentScrollTop + keyboardHeight + footerHeight
			}, 200)
		}
	}
}
